import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../../../components/ReUseAbleComponents/Shared";

function Topics(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-9">Design with pleasure</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>
                        <Link to="/forums">Forums</Link>
                      </li>
                      <li>Design with pleasure</li>
                    </ul>
                  </div>
                  <div className="table-responsive">
                    <table className="dx-table dx-table-default">
                      <thead>
                        <tr>
                          <th scope="col">Topics</th>
                          <th scope="col">Replies</th>
                          <th scope="col">Views</th>
                          <th scope="col">Last Post</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              How to choose Best Web Design C...
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Joseph Harper</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Fast web design for developers
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Garey Ross</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Mabel Nelson</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              How to make responsive web design?
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Edwin Hines</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Need help !!!
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Joseph Harper</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Having problem with Logo
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Sandra Reed</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Need help by creating a new site
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Alyson Tate</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Responsive slideshow?
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Michael Norton</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Which framework should I chose
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Abner Wilson</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Bootstrap Templates Directory
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Jane Palmer</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Joseph Harper</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row" className="dx-table-topics">
                            <Link
                              to="/single-topic"
                              className="dx-table-default-title"
                            >
                              Slideshows on the main page
                            </Link>
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </th>
                          <td>45</td>
                          <td>12058</td>
                          <td className="dx-table-lastPost">
                            <div className="dx-table-default-info">
                              <p className="mb-0">
                                by <Link to="/#">Admin</Link>{" "}
                                <span className="dib">24 Feb 2018,</span>{" "}
                                <span className="dib">09:00 am</span>
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <ul className="dx-pagination mt-40">
                <li className="dx-pagination-icon">
                  <Link to="/#">
                    <span className="icon pe-7s-angle-left"></span>
                  </Link>
                </li>
                <li>
                  <Link to="/#">1</Link>
                </li>
                <li className="dx-pagination-space">...</li>
                <li>
                  <Link to="/#">8</Link>
                </li>
                <li className="active">
                  <Link to="/#">9</Link>
                </li>
                <li>
                  <Link to="/#">10</Link>
                </li>
                <li className="dx-pagination-space">...</li>
                <li>
                  <Link to="/#">18</Link>
                </li>
                <li className="dx-pagination-icon">
                  <Link to="/#">
                    <span className="icon pe-7s-angle-right"></span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Topics;
